// Brand elements: splash screen (the yellow dot "pops" in after क) and the 7-dot streak.
import { useEffect, useState } from 'react';
import { useApp } from '../lib/store';
import { isInstalledApp } from '../lib/haptics';
import { Wordmark } from './Logo';

const SPLASH_KEY = 'kn-splash-seen';

export function Splash() {
  const [show, setShow] = useState(() => {
    // The installed apps show a native launch screen; never show a second, web splash there.
    if (isInstalledApp()) return false;
    try { return !window.sessionStorage.getItem(SPLASH_KEY); } catch { return true; }
  });
  useEffect(() => {
    if (!show) return;
    try { window.sessionStorage.setItem(SPLASH_KEY, '1'); } catch { /* ignore */ }
    const t = window.setTimeout(() => setShow(false), 1100);
    return () => window.clearTimeout(t);
  }, [show]);
  if (!show) return null;
  return (
    <div className="splash" role="presentation" onClick={() => setShow(false)}>
      <div className="splash-inner">
        <span className="splash-word"><Wordmark size={56} /></span>
        <span className="splash-tag" lang="hi">देखो कुछ नया हर रोज़</span>
      </div>
    </div>
  );
}

const DAY_NAMES = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];

/** Last 7 days. A filled dot means the person watched that day; today's dot is yellow. */
export function Streak({ compact = false }: { compact?: boolean }) {
  const progress = useApp((s) => s.progress);
  const watched = new Set(Object.values(progress).map((p) => new Date(p.updatedAt).toDateString()));
  const days = Array.from({ length: 7 }, (_, i) => {
    const d = new Date();
    d.setDate(d.getDate() - (6 - i));
    return { label: DAY_NAMES[d.getDay()], on: watched.has(d.toDateString()), today: i === 6 };
  });
  // Count back from today; if today has no video yet, the streak still counts from yesterday.
  let streak = 0;
  for (let i = days[6].on ? 6 : 5; i >= 0 && days[i].on; i--) streak++;
  return (
    <div className={'streak' + (compact ? ' compact' : '')} aria-label={`${streak}-day streak. Watch one video every day to keep it going.`}>
      {!compact && (
        <div className="streak-head">
          <b>{streak} day streak</b>
          <span className="muted small">Watch one video every day</span>
        </div>
      )}
      <ol className="streak-dots">
        {days.map((d, i) => (
          <li key={i} className={(d.on ? 'on' : '') + (d.today ? ' today' : '')}>
            <span className="streak-dot" />
            {!compact && <span className="streak-day">{d.label}</span>}
          </li>
        ))}
      </ol>
    </div>
  );
}
